<template>
    <div id="app">
        <nav class="navbar navbar-expand-md navbar-light">
            <div class="container expense-container">
                <div class="navbar-collapse expense-nav" id="navbar6">
                    <div class="title-wrapper">
                        <a class="navbar-brand text-primary d-md-block" href="\">
                            <i class="fa d-inline fa-lg fa-circle"></i>
                            <b> PSI Hub</b>
                        </a>
                    </div>
                    <div class="link-wrapper">
                        <ul class="navbar-nav">
                            <li class="nav-item"> <a class="nav-link" href="#">Welcome {{this.msal.user.userName}}</a> </li>
                        </ul>
                        <ul class="navbar-nav ml-auto top-right-nav">
                            <li class="nav-item">
                                <a href="https://sites.google.com/psi.edu/psihub-resources/home" target="_blank" class="nav-link" id="">Help</a>
                            </li>
                            <li class="nav-item">
                                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=psihub@psi.edu" target="_blank" class="nav-link">| Contact Us |</a>
                            </li>
                            <li class="nav-item"> 
                                <a class="nav-link" href="logout" @click="$msal.signOut()">Log Out </a>
                            </li>
                        </ul>
                        <!--<ul class="navbar-nav mx-auto"></ul>-->
                    </div>
                </div>
            </div>
        </nav>
        <div  v-if="isDeploymentDay() && !disableWarning" class="deploy-block">
            <div class="container update-container">
                <div style="display:flex">
                    <div class="warning"><span>&#9888;</span><span style="font-weight:bolder">System Maintenance</span></div>
                    <div class="close_button" @click="disableWarning=true">&#x2612;</div>
                </div>
                <div style="flex-basis:100%">System will be undergoing routing maintenance on {{this.displayDate}} between 10:00 p.m and 12:00 a.m.(Arizona Time). The site will remain accessible but certain functionalities may not be available.</div>
            </div>
        </div>
        <router-view />
        <notifications group="errors" position="bottom right" />
        <notifications group="success" position="bottom right" />
        <b-modal id="idle-modal" centered title="Warning" :hide-footer="true">
            We noticed you've been idle. You will automatically be logged out in 1 minute.
            <div class="d-flex align-items-center justify-content-end mt-2">
                <button type="button" class="btn btn-primary ml-1" @click="$bvModal.hide('idle-modal')">
                    I'm Still Here!
                </button>
            </div>
        </b-modal>
        <!-- footer could go here !-->
    </div>
</template>

<style lang="scss">
    /*ag-grid default styling */
    @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
    @import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
    @import "/custom.scss";
    @import "/assets/scss/styles.scss";

    /* override default highcolor in grid*/
    .ag-theme-balham .ag-row-selected {
        background-color: #12bbad;
    }

    /* override default theme styling adding button style for using onclick navigation */
    .btn-primary {
        color: #fff !important;
    }

    .btn-primary:hover {
        cursor: pointer;
    }

    .navbar-expand-md .navbar-collapse {
        justify-content: space-between;
        align-items: center;
    }

    .nav-contact, .nav-help {
        padding: .5rem .5rem !important;
    }

    .link-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }

    .nav-link-ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        padding: 0 1em;
        margin: 0 auto;
    }

    .nav-link {
        padding: 0 .3rem !important;
    }

    .nav-item:hover {
        text-decoration: underline !important;
    }

    .update-container {
        display: inherit;
        border: 1px solid black;
        margin: 10px;
        padding: 20px;
        -ms-flex-direction: column;
        -webkit-flex-direction: column;
        flex-direction: column;
    }

    .close_button {
        cursor: pointer;
        flex-basis:50%;
        text-align: right;
    }

    .warning {
        flex-basis: 50%;
        text-align: left;
        margin-bottom: 1%;
    }

    .deploy-block {
        align-items:center;
        display:flex;
        justify-content:center;
        font-size:large;
        font-weight:bolder;
    }
</style>

<script>
    export default {
        name: 'app',
        components: {
        },
        data: function () {
            return {
                displayDate: null,
                disableWarning: false
            }
        },
        created() {
            var self = this;
            window.onload = function () {
                var modalIdleTime;
                var logoutIdleTime;
                window.onload = resetTimer;
                document.onmousedown = resetTimer;
                document.onkeydown = resetTimer;

                function showInactivityModal() {
                    self.$bvModal.show('idle-modal');
                }

                function msalLogout() {
                    self.$msal.signOut();
                }

                function resetTimer() {
                    console.log("Made it");
                    if (modalIdleTime) {
                        clearTimeout(modalIdleTime);
                    }

                    if (logoutIdleTime) {
                        clearTimeout(logoutIdleTime);
                    }
                   
                    modalIdleTime = setTimeout(showInactivityModal, 3600000)
                    logoutIdleTime = setTimeout(msalLogout, 3600000)
                    // 1000 milliseconds = 1 second
                }
                resetTimer();
            }
        },
        methods: {
            isDeploymentDay() {
                const currentDate = this.moment();
                this.displayDate = currentDate.utcOffset('-0700').format('MM/DD/YY');
                return (currentDate.utcOffset('-0700').format('w') % 2 > 0) && (currentDate.day() == 3);
            }
        }
    }
</script>